
define('app/board/collections/pickSummaryCollection',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/models/pickSummaryModel'
], function($, _, Backbone, PickSummaryModel){
	var PickSummaryCollection = Backbone.Collection.extend({
		model : PickSummaryModel,
		lgInst: null,
		
		initialize: function(models, options) {
			this.lgInst = options.lgInst;
	    },
	    
	    getPosRoundId: function(round, posInRound){
	    	return (round*1000) + posInRound;
	    },
	    
	    getCurrentPosRoundId: function(){
	    	if(this.lgInst.get('draftType') != 'AUCTION'){
	    		//Find all the picks that haven't been skipped and don't have a player in them
	    		var foundPickSummaries = this.filter(function(pickSummary) {
		    		return ((pickSummary.get('draftablePlayerId') &&  pickSummary.get('draftablePlayerId') > 0) || pickSummary.get('skipped')) ? false : true;   		
		    	});
		    	
		    	this.lowestId = -1;
		    	
		    	_.each(foundPickSummaries, function(pickSummary, i){
					if(pickSummary.get('id') < this.lowestId || this.lowestId == -1){
						this.lowestId = pickSummary.get('id');
					}
				}, this);
		    	
		    	var curId = this.lowestId;
		    	delete this.lowestId;
		    	return curId;
	    	} else {
	    		var nomCountMap = {};
	    		var pickCountMap = {};
	    		var foundPosRoundId = 0;
	    		
	    		_.each(this.lgInst.getTeamList(), function(team, i){
	    			nomCountMap[team.get('draftPosition')] = 0;
	    			pickCountMap[team.get('draftPosition')] = 0;
	    		}, this);
	    		
	    		//Figure out how many opportunities each team has had to make a nomination
	    		var isPickFound = false;
	    		_.each(this.models, function(pickSummary, i){
	    			if(!isPickFound){
	    				if(!pickSummary.get('keeper') 
		    					&& pickSummary.get('auctionRound') 
		    					&& pickSummary.get('auctionRound') > 0
		    					&& pickSummary.get('auctionPosInRound') 
		    					&& pickSummary.get('auctionPosInRound') > 0){
		    				if(pickSummary.get('auctionValue') && pickSummary.get('auctionValue') == 0){
								//This is a nomination since the value hasn't yet been set
								foundPosRoundId = (pickSummary.get('auctionRound')*1000) + pickSummary.get('auctionPosInRound');
								isPickFound = true;
							} else if(pickSummary.get('auctionValue') && pickSummary.get('auctionValue') > 0){
								nomCountMap[pickSummary.get('auctionPosInRound')] = nomCountMap[pickSummary.get('auctionPosInRound')] + 1;	
								
								var fantTeam = this.lgInst.getTeam(pickSummary.get('fantasyTeamId'));
								pickCountMap[fantTeam.get('draftPosition')] = pickCountMap[fantTeam.get('draftPosition')] + 1;
							}
		    			} else if(pickSummary.get('auctionRound') 
		    					&& pickSummary.get('auctionRound') != 0
		    					&& pickSummary.get('auctionPosInRound') 
		    					&& pickSummary.get('auctionPosInRound') != 0
		    					&& pickSummary.get('auctionValue')
		    					&& pickSummary.get('auctionValue') > 0){							
		    				var fantTeam = this.lgInst.getTeam(pickSummary.get('fantasyTeamId'));
							pickCountMap[fantTeam.get('draftPosition')] = pickCountMap[fantTeam.get('draftPosition')] + 1;
		    			}
	    			}
				}, this);
	    		
	    		//If there is a nominated pick go ahead and return that right away
	    		if(foundPosRoundId > 0){
	    			return foundPosRoundId;
	    		}
	    		
	    		//Find out the lowest number of nominations a team has done
	    		var lowestNomCount = 999999;
	    		for(var curAuctionPosInRound in nomCountMap){
					var curCount = nomCountMap[curAuctionPosInRound];
					if(curCount < lowestNomCount && pickCountMap[curAuctionPosInRound] < this.lgInst.get('numRounds')){
						lowestNomCount = curCount;
					}
				}
	    		
	    		//Figure out which team has the lowest number of nominations and has the lowest draft position
	    		var nextPosInRound = 999999;
	    		var allSame = true;
	    		for(var curAuctionPosInRound in nomCountMap){
					var curCount = nomCountMap[curAuctionPosInRound];
					if(curCount == lowestNomCount && parseInt(curAuctionPosInRound) < nextPosInRound && pickCountMap[curAuctionPosInRound] < this.lgInst.get('numRounds')){
						nextPosInRound = parseInt(curAuctionPosInRound);
					}
				}
	    		
	    		//Return something if draft is over
	    		if(nextPosInRound >= 99999){
	    			return 1001; 
	    		}
	    		
	    		//Get a list of this team's nominated pick summaries
	    		var teamPickSummaries = _.filter(this.models, function(pickSummary) {
	    			if(pickSummary.get('auctionPosInRound') == nextPosInRound && !pickSummary.get('keeper') && pickSummary.get('auctionValue') && pickSummary.get('auctionValue') > 0){
	    				return true;
	    			} else {
	    				return false;
	    			}   		
		    	});
	    		
	    		//Find the next open spot
	    		var highestRound = 1;
	    		for (var i=1; true; i++) {
	    			var foundPickSum = null;
	    			_.each(teamPickSummaries, function(pickSummary, index){
						if(pickSummary.get('auctionRound') && pickSummary.get('auctionRound') == i){
							foundPickSum = pickSummary;
						}
					}, this);
	    			
	    			if(foundPickSum != null ){
	    				highestRound++;
	    			} else {
	    				break;
	    			}
				}
	    		
	    		return (1000 * highestRound) + nextPosInRound;
	    	}
	    	
	    }, 
	    
	    getLastPosRoundId: function() {
	    	if(this.lgInst.get('draftType') != 'AUCTION'){
	    		var foundPickSummaries = this.filter(function(pickSummary) {
		    		return (pickSummary.get('draftablePlayerId') &&  pickSummary.get('draftablePlayerId') > 0) ? true : false;   		
		    	});
		    	
		    	this.highestId = -1;
		    	
		    	_.each(foundPickSummaries, function(pickSummary, i){
					if(pickSummary.get('id') > this.highestId && !pickSummary.get('keeper')){
						this.highestId = pickSummary.get('id');
					}
				}, this);
		    	
		    	var curId = this.highestId;
		    	delete this.highestId;
		    	return curId;
	    	} else {
	    		var foundPickSummaries = this.filter(function(pickSummary) {
	    			if(!pickSummary.get('keeper') 
	    					&& pickSummary.get('auctionRound') 
	    					&& pickSummary.get('auctionRound') > 0
	    					&& pickSummary.get('auctionPosInRound') 
	    					&& pickSummary.get('auctionPosInRound') > 0){
	    				return true;
	    			} else {
	    				return false;
	    			}   		
		    	});
	    		
	    		var nomCountMap = {};
	    		var foundPosRoundId = 0;
	    		
	    		_.each(this.lgInst.getTeamList(), function(team, i){
	    			nomCountMap[team.get('draftPosition')] = 0;
	    		}, this);
	    		
	    		//Figure out how many opportunities each team has had to make a nomination
	    		var isPickFound = false;
	    		_.each(foundPickSummaries, function(pickSummary, i){
	    			if(!isPickFound){
	    				if(pickSummary.get('auctionValue') && pickSummary.get('auctionValue') == 0){
							//This is a nomination since the value hasn't yet been set
							foundPosRoundId = (pickSummary.get('auctionRound')*1000) + pickSummary.get('auctionPosInRound');
							isPickFound = true;
						} else if(pickSummary.get('auctionValue') && pickSummary.get('auctionValue') > 0){
							nomCountMap[pickSummary.get('auctionPosInRound')] = nomCountMap[pickSummary.get('auctionPosInRound')] + 1;
						}
	    			}
				}, this);
	    		
	    		//If there is a nominated pick go ahead and return that right away
	    		//This shouldn't actually be found since the nomination never sets a pick summary
	    		if(foundPosRoundId > 0){
	    			return foundPosRoundId;
	    		}
	    		
	    		//Find out the highest number of nominations a team has done
	    		var highestNomCount = 0;
	    		for(var curAuctionPosInRound in nomCountMap){
					var curCount = nomCountMap[curAuctionPosInRound];
					if(curCount > highestNomCount){
						highestNomCount = curCount;
					}
				}
	    		
	    		if(highestNomCount == 0){
	    			return -1;
	    		}
	    		
	    		//Figure out which team has the highest number of nominations and has the highest draft position
	    		var lastPosInRound = 0;
	    		for(var curAuctionPosInRound in nomCountMap){
					var curCount = nomCountMap[curAuctionPosInRound];
					if(curCount == highestNomCount && parseInt(curAuctionPosInRound) > lastPosInRound){
						lastPosInRound = parseInt(curAuctionPosInRound);
					}
				}
	    		
	    		//Get a list of this team's non-keepers
	    		var teamNonKeeperPickSummaries = _.filter(foundPickSummaries, function(pickSummary) {
	    			if(pickSummary.get('auctionPosInRound') == lastPosInRound
	    					&& pickSummary.get('auctionValue') 
	    					&& pickSummary.get('auctionValue') > 0){
	    				return true;
	    			} else {
	    				return false;
	    			}   		
		    	});
	    		
	    		//Find the next open spot
	    		var highestRound = 1;
	    		_.each(teamNonKeeperPickSummaries, function(pickSummary, i){
					if(pickSummary.get('auctionRound') && pickSummary.get('auctionRound') > highestRound){
						highestRound = pickSummary.get('auctionRound');
					}
				}, this);
	    		
	    		return (1000 * highestRound) + lastPosInRound;
	    	}
	    	
	    	
	    },
	    
	    getNextPosRoundAuctionKeeperId: function(fantTeamId) {
	    	var highestRound = -1;
	    	var team = this.lgInst.getTeam(fantTeamId);
	    	var nextPosInRound = (team.get('draftPosition') * -1);
	    	
	    	//Get a list of this team's pick summaries
    		var teamPickSummaries = _.filter(this.models, function(pickSummary) {
    			if(pickSummary.get('auctionPosInRound') == nextPosInRound
    					&& pickSummary.get('keeper')
    					&& pickSummary.get('auctionValue') && pickSummary.get('auctionValue') > 0
    					&& pickSummary.get('auctionRound') && pickSummary.get('auctionPosInRound') < 0){
    				return true;
    			} else {
    				return false;
    			}   		
	    	});
	    	
    		//Find the next open spot
    		for (var i=1; i < this.lgInst.get('numRounds'); i++) {
    			var foundPickSum = null;
    			_.each(teamPickSummaries, function(pickSummary, index){
					if(pickSummary.get('auctionRound') && pickSummary.get('auctionRound') == (i * -1)){
						foundPickSum = pickSummary;
					}
				}, this);
    			
    			if(foundPickSum != null){
    				highestRound--;
    			} else {
    				break;
    			}
			}
			
    		return (1000 * highestRound) + (team.get('draftPosition') * -1);
	    },
	    
	    getAucPickByPosRoundId: function(posRoundId){
	    	//Instantly return these results
	    	if(posRoundId == 0 || posRoundId == -1){
	    		return posRoundId;
	    	}
	    	
	    	this.auctionRound = 0;
	    	
	    	if(posRoundId > 0){
	    		this.auctionRound = Math.floor(posRoundId / 1000.0);
	    	} else {
	    		this.auctionRound = Math.ceil(posRoundId / 1000.0);
	    	}
	    	
	    	this.auctionPosInRound = posRoundId % 1000;
			this.pickSummary = null;
			
			this.each(function(pickSummary){
				if(pickSummary.get("auctionRound") == this.auctionRound 
						&& pickSummary.get("auctionPosInRound") == this.auctionPosInRound 
						&& pickSummary.get("auctionValue") > 0){
					this.pickSummary = pickSummary;
				}
			}, this);
			
			var pickSummary = this.pickSummary;
			delete this.auctionRound;
			delete this.auctionPosInRound;
			delete this.pickSummary;
			
			return pickSummary;
	    },
	    
	    isAuctionComplete: function() {
	    	this.complete = true;
	    	
	    	var isPickFound = false;
	    	this.each(function(pickSummary){
				if(!isPickFound && pickSummary.get("auctionValue") <= 0){
					this.complete = false;
					isPickFound = true;
				}
			}, this);
	    	
	    	var isComplete = this.complete;
	    	delete this.complete;
	    	
	    	return isComplete;
	    }
	});
	
	return PickSummaryCollection;  
});